exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".topPadding[data-v-5c64294d]{padding-top:16px}.md-tabs[data-v-5c64294d]{border-top:1px solid rgba(0,0,0,.12)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5c64294d","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/peers/PeerView.vue
// module id = 923
// module chunks = 0